import Cookies from 'js-cookie';
import {jwtDecode} from "jwt-decode";
import {Buffer} from "buffer";

let BASE_URL = "/api/v2";

function base64URLEncode(buffer: ArrayBuffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}

async function sha256(buffer: Uint8Array): Promise<ArrayBuffer> {
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    return hashBuffer;
}

export async function RefreshToken(code: string) {
    const url = BASE_URL + "/auth/login/sso/refresh";

    let response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            refreshToken: code
        }),
    });
    if (response.ok) {
        const response_data = await response.json();
        Cookies.set("__session", response_data.response, { sameSite: 'Strict' });
        return jwtDecode(response_data.response);
    } else {
        throw new Error(response.statusText);
    }
}

export async function GetSsoToken(code: string) {
    const url = BASE_URL + "/auth/login/sso/token";
    const verifier = sessionStorage.getItem('verifier');
    const email = sessionStorage.getItem('email');

    let redirect_uri = window.location.protocol + '//' + window.location.host + '/auth';

    let response = await fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            code: code,
            verifier: verifier,
            redirectURL: redirect_uri,
            email
        }),
    });
    if (response.ok) {
        const response_data = await response.json();
        Cookies.set("__session", response_data.response, { sameSite: 'Strict' });
        return jwtDecode(response_data.response);
    } else {
        throw new Error(response.statusText);
    }
}

async function getSsoUrlFromBackend(user: string) {
    const url = BASE_URL + "/auth/login/sso?email=" + user;

    let response = await fetch(url, {
        method: "GET"
    });
    if (response.ok) {
        const responseData = await response.json();
        return responseData.response;
    } else {
        throw new Error(response.statusText);
    }
}

export async function getSSOUrl(user: string, router: any) {
    try {
        let ssoConfig = await getSsoUrlFromBackend(user);
        const verifierArray = window.crypto.getRandomValues(new Uint8Array(32)).buffer;
        const verifier = base64URLEncode(verifierArray);
        const challenge = base64URLEncode(await sha256(Buffer.from(verifier)));
        const ssoURL = new URL(ssoConfig);
        const redirect = new URL(window.location.protocol + '//' + window.location.host + '/auth');
        ssoURL.searchParams.append('response_type', 'code');
        ssoURL.searchParams.append('redirect_uri', redirect.toString());
        ssoURL.searchParams.append('code_challenge', challenge);
        ssoURL.searchParams.append('code_challenge_method', 'S256');

        sessionStorage.setItem('verifier', verifier);
        sessionStorage.setItem('email', user);
        return ssoURL.toString();
    } catch (e) {
        console.log(e);
        throw Error("An error occurred while logging in");
    }
}